<template>
  <div class="l_model_change_faq">
    <div class="container">
      <div class="content">
        <h3>STEP1 / 機種変更前の準備：IDの保管</h3>
        <hr />
        <p>
          機種変更の際に、アプリ会員ID・パスワードを入力することで、元のアプリにたまっていたスタンプやクーポン・特典などのデータを引き継いでご利用いただけます。<br />
          まず、機種変更前のIDを保管しておくことが必要になります。<span
            class="strong-red"
            >ID・パスワードが不明な場合、ポイントやクーポンを引き継ぐことができません</span
          >のでご注意ください。<br />
          <br />
          また、Apple IDを連携しておけば、機種変更後もApple IDを使ってデータを引き継ぐことができます。<br />
          ※Apple ID連携はiOS13以上対応です。
          <br />
          <br />
          <span class="strong brown">■アプリ会員IDを保存</span><br />
          下記のアプリ会員ID・パスワードを保存しておいてください。<br />
          <br />
          <span class="strong">【IDの保存方法】</span><br />
          <span class="strong">●画面キャプチャで保存</span><br />
          下記のアプリ会員ID・パスワードの下にある<span class="strong"
            >「画面キャプチャ」</span
          >ボタンを押下しますと、写真フォルダに画面が保存されますので大切に保管してください。<br />
          <br />
          <span class="strong">●メールを送信して保存</span><br />
          下記の<span class="strong"
            >「アプリ会員 ID・パスワードを自分宛にメールする」</span
          >ボタンを押下しますと、メールが立ち上がりますのでご自分のメールアドレスを入力後送信してください。<br />
          メールの受信を確認後、アプリ会員ID・パスワードの書かれたメールを大切に保管してください。
        </p>

        <p class="account-info">あなたのアプリ会員ID・パスワード</p>
        <div class="border">
          <span class="caption">アプリ会員ID：</span>
          <span class="strong">{{ this.userId }}</span>
        </div>
        <div class="border bottom">
          <span class="caption">パスワード：</span>
          <span class="strong">{{ this.password }}</span>
        </div>
        <p style="font-size:10px;color:#666;margin-top:8px;">
          ※旧バージョンのアプリではパスワードが表示されません。お手数ですが最新版のアプリにアップデートをお願いいたします。
        </p>
        <div class="l_button__external">
          <UIButton
            :label="'画面キャプチャ'"
            :icon="'icon-capture'"
            @click="tapScreenShot"
          />
        </div>
        <div class="l_button__external mail">
          <UIButton
            :label="'アプリ会員ID・パスワードを自分宛にメールする'"
            @click="tapUserId"
          />
        </div>
        <br />
        <br />
        <span class="strong brown">■Apple IDを連携</span><br />
        下記のボタンを押して、Apple IDを連携してください。<br />
        ※Apple ID連携はiOS13以上対応です。
        <router-link to="/siwa">
          <img :src="require('@/assets/img/siwa/to_appleid_button.png')" style="border: none; width: 90%" />
        </router-link>
        <br />
        <br />
        <h3>STEP2 / 機種変更後の手続き</h3>
        <hr />
        <p>
          機種変更後、アプリをインストールしますと下記の画面が表示されますので、「会員IDを引き継ぐ」のボタンを押下してください。
          <img :src="require('@/assets/img/data-inherit/step2-1.png')" />
          次に、下記のページが表示されますので、アプリ会員IDで引き継ぎをされる方は STEP1で保存していただいた、アプリ会員ID・パスワードを入力の上、「アプリ会員IDでデータ引き継ぎ」ボタンを押下してください。<br><br>
          さらに、Apple ID をリンクしている場合は、「Appleでサインイン」をクリックしてください。<br>
          機種変更前にID連携をしないまま、引き継ぎページから引き継ぎを行なっても引き継ぎはできません。<br>
          新しいアプリ ID と既存の Apple ID がリンクされます。
          <img :src="require('@/assets/img/data-inherit/step2-2.png')" style="border:none; width: 90%" />
        </p>

        <br />

        <h3>STEP3 / 引き継ぎでお困りの時は</h3>
        <hr />
        <p>
          STEP1、STEP2に従って引き継ぎができない場合は、下記のお問い合わせより機種変更された旨をご連絡の上、<span
            class="strong-red"
            >機種変更前のアプリ会員IDとパスワード・機種変更後のアプリ会員IDとパスワード</span
          >をお知らせください。（アプリ会員IDは自動入力されます。）<br />
          <br />
          <span class="strong-red"
            >以前のアプリ会員IDやパスワードがわからない場合は、ポイントやクーポンを引き継ぐことができません。</span
          >あらかじめご了承ください。
        </p>
        <router-link to="/faq/inquiry" @click.native="tapInquiry">
          <div class="l_button__external">
            <UIButton :label="'お問い合わせ'" />
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'

export default {
  name: 'FAQModelChange',
  components: { UIButton },
  data: function() {
    return {
      userId: '',
      password: ''
    }
  },
  created() {
    document.title = '機種変更時の手続きについて'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.userId = json.user_id
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({ apiType: '3', acc_time: accTime })
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedPassword = payload => {
        this.password = payload
        window.receivedPassword = null
      }
      this.actionRequestPassword()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionGetScreenShot',
      'actionRequestPassword'
    ]),
    goBack: function() {
      this.$router.push({ name: 'FAQ' })
    },
    tapUserId: function() {
      this.trackEvent(FactoryTrack.createFAQModelChangeSendId())
      const address = ''
      const subject = '香の川製麺アプリ会員ID・パスワード'
      let body = encodeURIComponent(
      `アプリ会員ID： ${this.userId}\n` +
      `パスワード： ${this.password}\n\n` +
      `※機種変や再インストールの際に必要になりますので、大切に保管しておいてください。`
    )
      location.href =
        'mailto:' + address + '?subject=' + subject + '&body=' + body
    },
    tapInquiry: function() {
      this.trackEvent(FactoryTrack.createFAQInquiry())
      //   const address = 'support@joyfull.support'
      //   const subject = 'アプリに関するお問い合わせ'
      //   let body = `%0d%0a\
      //   アプリ会員ID： ${this.userId}%0d%0a\
      //   %0d%0a\
      //   来店した店舗名：%0d%0a\
      //   %0d%0a\
      //   来店した日時：%0d%0a\
      //   ※おおよその時刻で結構です。%0d%0a\
      //   %0d%0a\
      //   お問い合わせ内容：%0d%0a\
      //   ※「来店してもスタンプがもらえない」「QRコードが案内されない」など%0d%0a\
      //   ※機種変更の際は、機種変更された旨と以前使われていたアプリ会員IDをお知らせください。%0d%0a\
      //   【送信前にご確認下さい】%0d%0a\
      //   ※土・日・祝日にいただいたお問合せは翌営業日の受付となります。%0d%0a\
      //   ※support@joyfull.supportよりご返信させて頂きますので、メール受信制限等を設定されている場合は、左記のアドレスを受信して頂けるよう設定の変更をお願い致します。%0d%0a\
      //   `
      //   location.href =
      //     'mailto:' + address + '?subject=' + subject + '&body=' + body
    },
    tapScreenShot() {
      this.trackEvent(FactoryTrack.createGetScreenShot())
      this.actionGetScreenShot()
    }
  }
}
</script>

<style scoped lang="scss">
.l_model_change_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_model_change_faq h3,
.l_model_change_faq h4 {
  color: var(--accent-color);
}

.brown {
  color: #602209;
}

.l_model_change_faq h4 {
  margin: 10px 0px;
}

.l_model_change_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}
.l_model_change_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}
.l_model_change_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid var(--accent-color);
}
.l_model_change_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.l_model_change_faq span.strong {
  font-weight: bold;
  &.red {
    color: #cc0000;
  }
}
.screenshot {
  text-align: center;
  img {
    width: 75%;
    margin: auto 0;
  }
}

p.account-info {
  margin-top: 1em;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: bold;
}

div.border {
  margin: 0;
  padding: 20px 0;
  border-top: 1px solid gray;
  text-align: left;

  &.bottom {
    border-bottom: 1px solid gray;
  }

  .caption {
    display: block;
    font-size: 12px;
    text-align: left;
  }
}

.mail button {
  padding-left: 20px;
  padding-right: 20px;
}

img {
  max-width: 80%;
  width: 188px;
  display: block;
  border: 1px solid #dedede;
  margin: 0 auto;
}
.strong {
  font-weight: bold;
}

.strong-red {
  font-weight: bold;
  color: #e03535;
}
</style>
